import { Record } from 'immutable';
class ErrorState extends Record({
  hasConflictError: false,
  hasUnknownError: false
}, 'ErrorState') {}
ErrorState.fromJS = obj => new ErrorState(Object.assign({}, obj));
export default ErrorState;